<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="stocksSelected"
    clearable
    chips
    multiple
    deletable-chips
    small-chips
    :items="stocksItems"
    :loading="stocksLoading"
    :search-input.sync="stocksSearch"
    item-text="Description"
    item-value="id"
    :label="$t('Stock.ObjectName')"
    return-object
  ></v-autocomplete>
</template>

<script>
import Stocks from "@/api/stocks";

export default {
  name: "SearcherStocks",

  props: {
    value: Array,
  },

  computed: {
    stocksItems() {
      return this.stocks.map((stock) => {
        const Description = stock.code + " / " + stock.name;
        return Object.assign({}, stock, { Description });
      });
    },
  },

  data: () => ({
    stocks: [],
    stocksLoading: false,
    stocksSearch: "",
    stocksSelected: [],
  }),

  mounted() {
    this.stocksLoading = true;
    Stocks.fetchAllForSelect({})
      .then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stocks = response.data.stocks;
          }
          this.stocksLoading = false;
        }.bind(this)
      )
      .catch(
        function () {
          this.stocksLoading = false;
        }.bind(this)
      );
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.stocksSelected = this.value;
      },
    },
    stocksSelected: {
      handler() {
        this.$emit("input", this.stocksSelected);
      },
    },
  },
};
</script>